export default "__VITE_ASSET__BwN2tbQB__"